export const honeycombDataSpanish = {
  contentArray: [
    {
      ID: 1,
      tabTitle: 'Cambio de sistema',
      leftColumnTitle: 'Variables del sistema',
      scenarioParameters: {
        systemScale: 'Cuota de mercado: ~40%',
        systemScaleSub:
          'Gran cambio hacia la reutilización dentro de una infraestructura muy compartida',
        infrastructure: 'Embalaje colectivo',
        packaging: 'Embalaje colectivo',
        returnRate: '95% (permite reutilizar los envases ~15 veces)',
      },
      chartURL:
        'https://emf.thirdlight.com/file/24/DYu4HUqDY7F5cPyDYf74DEOZ9Hb/Scenario-1-Data-Vis.png',
      imageCaption:
        'Tramo final de transporte desde "clasificación y limpieza" hasta "rellenado"',
      mapURL:
        'https://emf.thirdlight.com/file/24/K6LOnIrK6Tvhpj0K63dkKvtt3sG/Honeycomb-S1-map.jpg',
      vimeoURL:
        'https://player.vimeo.com/video/858925722?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
    {
      ID: 2,
      tabTitle: 'Acción en colaboración',
      leftColumnTitle: 'Variables del sistema',
      scenarioParameters: {
        systemScale: 'Cuota de mercado: ~10%',
        systemScaleSub:
          'Es posible mediante grandes cambios de volumen hacia la reutilización y el uso compartido de infraestructuras',
        infrastructure: 'Envases a medida',
        packaging: 'Medio',
        returnRate: '90% (permite reutilizar los envases ~10 veces)',
      },
      chartURL:
        'https://emf.thirdlight.com/file/24/Om5sTEKOmpAvdhwOmSpsOmPYGL6/Scenario-2-Data-Vis.png',
      imageCaption:
        'Tramo final de transporte desde "clasificación y limpieza" hasta " rellenado"',
      mapURL:
        'https://emf.thirdlight.com/file/24/gVKyImJgVEq7RHHgVp2CgzBQkX6/Honeycomb-S2-map.jpg',
      vimeoURL:
        'https://player.vimeo.com/video/858926532?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
    {
      ID: 3,
      tabTitle: 'Esfuerzo fragmentado',
      leftColumnTitle: 'Variables del sistema',
      scenarioParameters: {
        systemScale: 'Cuota de mercado: ~2%',
        systemScaleSub:
          'Debido a los bajos volúmenes y a la fragmentación de las infraestructuras',
        infrastructure: 'Envases a medida',
        packaging: 'Alta',
        returnRate: '80% (permite reutilizar los envases ~5 veces)',
      },
      chartURL:
        'https://emf.thirdlight.com/file/24/fBFIqehfBD0ALZNfBtDIfRWdTD/Scenario-3-Data-Vis.png',
      mapURL:
        'https://emf.thirdlight.com/file/24/pN3kJWTpNghDycLpNO18phIngnK/Honeycomb-S3-map.jpg',
      imageCaption:
        'Tramo final de transporte desde "clasificación y limpieza" hasta " rellenado"',

      vimeoURL:
        'https://player.vimeo.com/video/858926809?background=1&badge=0&autoplay=1&loop=1&autopause=0&player_id=0&app_id=58479',
    },
  ],
  visualisationButtons: [
    'Escenario visual',
    'Resultados de la modelización de escenarios',
  ],
  mapURLs: [
    'https://emf.thirdlight.com/file/24/K6LOnIrK6Tvhpj0K63dkKvtt3sG/Honeycomb-S1-map.jpg',
    'https://emf.thirdlight.com/file/24/gVKyImJgVEq7RHHgVp2CgzBQkX6/Honeycomb-S2-map.jpg',
    'https://emf.thirdlight.com/file/24/pN3kJWTpNghDycLpNO18phIngnK/Honeycomb-S3-map.jpg',
  ],
};
